module.exports = __webpack_public_path__ + "static/media/lunchclub-logo.60fe1b3a.svg";